import { Button } from "../Button/index.js";
import { Pagination } from "../Pagination/index.js";
import { cn } from "@synthesis/shared-utils";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/TableAg/TablePagination.tsx
const PAGINATION_BUTTON_SIZE = "sm";
const PAGINATION_INACTIVE_THEME = "text";
const TablePagination = ({ totalItems, pageSize, currentPage, pageSizeSelector, onPageChange, onPageSizeChange, className }) => {
	const hasPageSizeSelector = Boolean(pageSizeSelector?.length);
	if (totalItems <= 0 && !hasPageSizeSelector) return null;
	return /* @__PURE__ */ jsxs("nav", {
		"data-cy": "table-pagination",
		"aria-label": "Пагинация таблицы",
		className: cn("flex w-full shrink-0 items-center justify-between pt-4", className),
		children: [/* @__PURE__ */ jsx(Pagination, {
			totalItems,
			itemsPerPage: pageSize,
			currentPage: Math.max(1, currentPage),
			setCurrentPage: onPageChange,
			size: PAGINATION_BUTTON_SIZE,
			inactiveTheme: PAGINATION_INACTIVE_THEME,
			className: "items-center justify-start gap-2 pb-0"
		}), hasPageSizeSelector ? /* @__PURE__ */ jsx("div", {
			"data-cy": "table-pagination-page-size",
			className: "flex items-start gap-2",
			role: "group",
			"aria-label": "Строк на странице",
			children: pageSizeSelector?.map((size) => {
				const isActive = size === pageSize;
				return /* @__PURE__ */ jsx(Button, {
					"data-cy": `table-pagination-page-size-${size}`,
					onClick: () => onPageSizeChange(size),
					size: PAGINATION_BUTTON_SIZE,
					shape: "square",
					theme: isActive ? "primary" : PAGINATION_INACTIVE_THEME,
					"aria-pressed": isActive,
					children: size
				}, size);
			})
		}) : null]
	});
};
//#endregion
export { TablePagination };

//# sourceMappingURL=TablePagination.js.map